// extracted by mini-css-extract-plugin
export default {"formField":"Poa-z","error":"Qoa-z","disabled":"Roa-z","fieldError":"Soa-z","errorText":"Toa-z","linkButton":"Uoa-z","noCode":"Voa-z","button":"Woa-z","acknowledgment":"Xoa-z"};